<app-topheader></app-topheader>
<div class="scrollingcontainer ">

    <div class="container">
        <app-fancy-page-title topTitle="DINING ABOARD" subTitle=""></app-fancy-page-title>

        <app-longgoldbar></app-longgoldbar>

        <div class="row">
            <!-- <div class="col-2">
                <button class="btn btn-outline-secondary">Back</button>
            </div> -->
            <div class="col-1">

            </div>
            <div class="col-10">
                <button class="btn btn-outline-secondary btn-light" [routerLink]="['/mealdescription']">Restaurant Menu
                    and Selections</button>
            </div>
        </div>
        <!-- API - Cafe Name (only show View Back Porch Cafe Menu button below if it applies to a cruise)-->
        <div>
            <div *ngFor="let cafemenunamedata of cafemenunames; let i = index;">
                <div *ngIf="i==0 && cafemenunamedata.slnName!='' && cafemenunamedata.ltyname=='Cafe'">
                    <!-- display the cafe name if the ship has a cafe & the cafe field name isn't empty -->
                    <div class="row">
                        <div class="col-1"></div>

                        <div class="col-10">
                            <button class="btn btn-outline-secondary btn-light"
                                [routerLink]="['/cafedescription']">{{cafemenunamedata.slnName}}&nbsp;Menu</button>
                            <!-- cafe name = Lookout Cafe -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tenpxtop"></div>

        <app-dining-times></app-dining-times>
        <div class="tenpxtop"></div>

    </div>
</div>
<app-bottommenu></app-bottommenu>